import { OnInit, Component } from "@angular/core";
import { YepdeskEventsBaseComponent } from "@moduurnv2/libs-orderingapp/src";


@Component({
  selector: 'yepdesk-events-desktop',
  templateUrl: './yepdesk-events-desktop.component.html',
  styleUrls: ['./yepdesk-events-desktop.component.scss'],
})
export class yepdeskEventsDesktopComponent extends YepdeskEventsBaseComponent  implements OnInit {
 
}
